<template>
  <header
    class="home-header"
    :class="{ 'home-header--expanded': expanded }"
    :style="expanded ? `padding-top: ${SafeAreaView.top + 12}px` : ''"
  >
    <RouterLink
      v-if="showMenu"
      to="/menu"
      class="home-header__menu"
      draggable="false"
      :aria-label="t('home.menu')"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.4"
        stroke-linecap="round"
      >
        <path d="M4 7h16M4 12h16M4 17h16" />
      </svg>
    </RouterLink>

    <button
      type="button"
      class="home-header__search"
      @click="router.push('/search')"
    >
      <span>{{ expanded ? t('home.searchExpanded') : t('home.searchCollapsed') }}</span>
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      >
        <circle
          cx="11"
          cy="11"
          r="7"
        />
        <path d="m20 20-3.5-3.5" />
      </svg>
    </button>
  </header>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { SafeAreaView } from '@/helpers/getSafeArea'

defineProps({
  expanded: {
    type: Boolean,
    default: false,
  },
  showMenu: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const router = useRouter()
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 4px;

  &--expanded {
    padding-bottom: 20px;
    background: #9ad03b;
    border-radius: 0 0 32px 32px;
  }

  &__menu {
    flex: none;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #fff;
    color: #26384b;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__search {
    flex: 1;
    min-width: 0;
    height: 48px;
    padding: 0 20px;
    border: 1px solid #e8eafc;
    border-radius: 24px;
    background: #fff;
    color: #8f98ab;
    font-size: 15px;
    font-family: "NunitoRegular";
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    cursor: pointer;

    svg {
      flex: none;
      color: #55627a;
    }
  }
}

[theme="dark"] {
  .home-header__menu,
  .home-header__search {
    background: #37363c;
    border-color: #37363c;
    color: #b0b2c2;
  }

  .home-header__menu {
    color: #fff;
  }
}
</style>
